/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LogicModuleType = {
    COUNTER_GOAL: 'COUNTER_GOAL',
    COUNTER_PER_EVENT: 'COUNTER_PER_EVENT',
    STREAK_EVENT: 'STREAK_EVENT',
    STREAK_TIME: 'STREAK_TIME',
    STREAK_LIMITER: 'STREAK_LIMITER',
    NULLIFIER: 'NULLIFIER',
    PROGRESSIVE_LADDER: 'PROGRESSIVE_LADDER',
    PHOTO: 'PHOTO'
} as const;
export type LogicModuleType = typeof LogicModuleType[keyof typeof LogicModuleType];


export function instanceOfLogicModuleType(value: any): boolean {
    for (const key in LogicModuleType) {
        if (Object.prototype.hasOwnProperty.call(LogicModuleType, key)) {
            if (LogicModuleType[key as keyof typeof LogicModuleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LogicModuleTypeFromJSON(json: any): LogicModuleType {
    return LogicModuleTypeFromJSONTyped(json, false);
}

export function LogicModuleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogicModuleType {
    return json as LogicModuleType;
}

export function LogicModuleTypeToJSON(value?: LogicModuleType | null): any {
    return value as any;
}

export function LogicModuleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LogicModuleType {
    return value as LogicModuleType;
}

